import React from "react"
import PropTypes from "prop-types"
import { InlineText, SubTitle, Title } from "../Typography/Typography"
import Smartlink from "../layout/SmartLink/SmartLink"
import ShowMore from "../ShowMore/ShowMore"
import Card from "../layout/card"
import getGeoSpecificText from "./geoSpecificTextUtil"
import { renderIf } from "../FeatureToggle/FeatureToggle"

const careTypes = {
  care_home: "care home",
  home_care: "home care",
}

export default function GeoSpecificText({ geoSelf, careType, currentUrl }) {
  const showMoreClickEvent = () => ({
    name: "SEO Filtered Directory - Show more copy clicked",
    properties: {
      "Care Type": careType,
      "GEO Location": geoSelf.locationName,
      "Current URL": currentUrl,
    },
  })
  const careGuideDownloadClickEvent = () => ({
    name: "SEO Filtered Directory - Copy link to download care guide clicked",
    properties: {
      "Care Type": careType,
      "GEO Location": geoSelf.locationName,
      "Current URL": currentUrl,
    },
  })

  const text = getGeoSpecificText(geoSelf)
  const RenderIfGeoSpecificText = renderIf(!!text)

  return (
    <RenderIfGeoSpecificText>
      <Card>
        {text?.title ? (
          text?.title
        ) : (
          <Title marginBottom>
            Finding the right {careType ? careTypes[careType] : "care"} in{" "}
            {geoSelf.locationName}
          </Title>
        )}
        {text.summary}

        <ShowMore
          moreTitle={<InlineText brand>Show More</InlineText>}
          lessTitle={<InlineText brand>Show Less</InlineText>}
          moreTitleText="Show More"
          lessTitleText="Show Less"
          clickEvent={showMoreClickEvent(
            careType,
            geoSelf.locationName,
            currentUrl,
          )}
        >
          {text.content}

          {text?.ourExpectCareGuide ? (
            text.ourExpectCareGuide
          ) : (
            <div>
              <SubTitle marginBottom bold>
                Our expert care guide
              </SubTitle>
              <InlineText>
                If you can’t quite make your mind up yet, and would like some
                more detailed advice on how to select the right care home for
                your loved one, you can{" "}
                <Smartlink
                  to="https://www.caresourcer.com/guide-to-finding-the-right-care-home/"
                  clickEvent={careGuideDownloadClickEvent(
                    careType,
                    geoSelf.locationName,
                    currentUrl,
                  )}
                  newTab
                >
                  <InlineText brand>download our expert guide</InlineText>
                </Smartlink>
                . Written by one of our very own UK care experts, the guide
                focuses on understanding regulatory ratings, reading between the
                lines in reviews and the questions you should ask prospective
                care homes when you call to enquire.
              </InlineText>
            </div>
          )}
        </ShowMore>
      </Card>
    </RenderIfGeoSpecificText>
  )
}

GeoSpecificText.propTypes = {
  geoSelf: PropTypes.object.isRequired,
  careType: PropTypes.string.isRequired,
  currentUrl: PropTypes.string.isRequired,
}
